import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Routes from './routes'
// import * as serviceWorker from './serviceWorker';
/* eslint import/no-webpack-loader-syntax: off */
/* eslint  no-undef: off */

import { BrowserRouter } from 'react-router-dom';
import registerInterceptor from "./interceptor";
import { Provider } from 'react-redux';
import store from './store/index';
import { createBrowserHistory } from "history";

registerInterceptor();
const history = createBrowserHistory();

ReactDOM.render(
		<Provider store={ store }>
			<React.StrictMode>
				<BrowserRouter>
					<Routes history={history}/>
				</BrowserRouter>
			</React.StrictMode>
		</Provider>,
		document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
